import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorIcon"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/oss/app/(panel)/SidebarCollapseButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarLinksList","default"] */ "/app/oss/app/(panel)/SidebarLink.tsx");
;
import(/* webpackMode: "eager" */ "/app/oss/app/(panel)/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/oss/app/(panel)/TopBarHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/oss/components/atoms/Link/LinkWithEagerPrefetching.tsx");
;
import(/* webpackMode: "eager" */ "/app/oss/components/atoms/Skeleton/Skeleton.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/oss/components/molecules/AllUnreadChatMessagesCountDot/AllUnreadChatMessagesCountDot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/oss/components/molecules/LogoutButton/LogoutButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/Avatar/Avatar.module.css");
;
import(/* webpackMode: "eager" */ "/app/oss/components/molecules/OrganizationImage/OrganizationImage.module.css");
;
import(/* webpackMode: "eager" */ "/app/shared/components/Box/Box.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/ImageOrPlaceholderOnError/ImageOrPlaceholderOnError.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/Skeleton/Skeleton.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/app/shared/context/UserContext.tsx");
